import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styles from "./MenuSection.module.scss";
import { Container } from "react-bootstrap";
import Hamburger from "hamburger-react";
import { IoIosArrowDropupCircle } from "react-icons/io";
import { LightLogo } from "../../../components/SvgIcons";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "stores/RootStore";

const MenuSection: React.FC = observer(() => {
  const [sticky, setSticky] = useState<boolean>(false);
  const [menuOpen, setMenuOpen] = useState<boolean>(false);

  const location = useLocation();
  const handleToggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      setSticky(offset > 0);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (location.hash) {
      const elementId = location.hash.replace("#", ""); // Убираем #
      const element = document.getElementById(elementId);
      if (element) {
        const offset = 100;
        const elementPosition =
          element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: elementPosition - offset,
          behavior: "smooth",
        });
      }
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [location]);

  const topScroll = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const menu = [
    {
      title: "О нас",
      path: "/#about",
    },
    /*{
      title: "Услуги",
      onclick: () => {},
    },*/
    {
      title: "Преимущества",
      path: "/#reliably",
    },
    {
      title: "Маркетплейсы",
      path: "/#marketplaces",
    },
    {
      title: "Поставщикам",
      path: "/suppliers",
    },
    {
      title: "Тарифы",
      path: "/suppliers#tariffs",
    },
    {
      title: "Условия",
      path: "/terms",
    },
    {
      title: "Контакты",
      path: "/#contacts",
    },
  ];

  return (
    <div className={styles.Menu}>
      <Container className={styles.MenuHeader}>
        <div className={styles.MobileMenu}>
          <Link to="/" className={styles.Logo}>
            <LightLogo />
          </Link>
          <div className={styles.ToggleMenu}>
            <Hamburger
              toggled={menuOpen}
              toggle={handleToggleMenu}
              color="#fff"
              size={42}
            />
          </div>
        </div>
        {menuOpen && (
          <ul className={styles.MenuMobileUl}>
            {menu.map(({ title, path }) => {
              return (
                <Link to={path} key={path}>
                  <li>{title}</li>
                </Link>
              );
            })}
          </ul>
        )}

        <ul className={styles.MenuUl}>
          {menu.map(({ title, path }) => {
            return (
              <Link to={path} key={path}>
                <li>{title}</li>
              </Link>
            );
          })}
        </ul>
      </Container>
      <IoIosArrowDropupCircle
        color="#f49100"
        size={72}
        className={sticky ? styles.scrollTop : styles.scrollTopHidden}
        onClick={() => topScroll()}
      />
    </div>
  );
});

export default MenuSection;
